import React, {useEffect, useRef, useState} from 'react';
import classnames from "classnames";

const Tabs = ({ activeKey, className, tabs, onChange }) => {
    const componentClass = 'tabSlider';
    const [activeTab, setActiveTab] = useState(activeKey || activeKey === 0 ? activeKey : tabs[0].key);
    const [tabStyle, setTabStyle] = useState({});
    const tabRef = useRef(null);
    const classes = classnames(componentClass, className);
    const targetTabKey = activeKey || activeKey === 0 ? activeKey : activeTab;

    useEffect(() => {
        const activeTabElement = tabRef.current.querySelector(".active");
        const newTabStyle = {
            left: activeTabElement.offsetLeft,
            width: activeTabElement.offsetWidth
        };
        setTabStyle(newTabStyle);
    }, [activeKey]);

    const handleTabClick = tabId => {
        const newActiveTabElement = tabRef.current.querySelector(`#tab-${tabId}`);
        const newTabStyle = {
            left: newActiveTabElement.offsetLeft,
            width: newActiveTabElement.offsetWidth
        };
        setTabStyle(newTabStyle);
        setActiveTab(tabId);
        onChange && onChange(tabId);
    };

    return (
        <div className={classes}>
            <div className={`${componentClass}__container`} ref={tabRef}>
                {
                    tabs.map((tab) => (
                        <div
                            key={tab.key}
                            className={`${componentClass}__tab ${targetTabKey === tab.key ? "active" : ""}`}
                            onClick={() => handleTabClick(tab.key)}
                            id={`tab-${tab.key}`}
                        >
                        {tab.label}
                    </div>
                    ))
                }
                    <div className={`${componentClass}__slider`} style={tabStyle}></div>
            </div>
        </div>
    );
};

const TabSliderContent = ({ className, tabs, activeKey }) => {
    const componentClass = 'tabSliderContent';
    const classes = classnames(componentClass, className);

    const renderContent = () => {
        let render = 'Nothing to see here...';
        if (Array.isArray(tabs)) {
            for (let index = 0; index < tabs.length; index++) {
                const tabConfig = tabs[index];
                if (tabConfig?.key === activeKey) {
                    render = tabConfig?.children || 'Nothing setup for this tab...';
                    break;
                }
            }
        }
        return render;
    }

    return <div className={classes}>{ renderContent() }</div>;
}

export default Tabs;
export { TabSliderContent };
